import React from 'react';
import MettingHexa from '../../assets/MettingHexa.jpg'


const AboutUs = () => {

  return <div>

    
    <div style={{paddingTop:'10%', paddingBottom:'10%', color:'white', fontSize: 20, paddingLeft:'10%', paddingRight:'10%'}}>
    <h1>About US</h1>
    ParLock(New Look) - We are ParLock ! The leading NFT-focused website, reaching 1.2M views monthly, 100% organically. 

<br/>

<div style={{paddingTop:'1%', paddingBottom:'1%', color:'white', fontSize: 20}}>
We cover NFT news for the whole ecosystem – Whether it’s digital art, gaming, collectibles, music
</div>
<div style={{paddingTop:'1%', paddingBottom:'1%', color:'white', fontSize: 20}}>
Our goal is to create fun and accessible content whilst building one single place to accompany any investor, artist or NFT-enthusiast on their NFT journey
</div>

One phenomenon that has challenged the way we think of ownership is NFTs (non-fungible tokens). They have a blockchain-based approach to proving ownership and authenticity. While they aren’t exactly a new concept, they’ve entered the public realm relatively recently when fully digital artworks were auctioned at mind-boggling prices. 

Innovation comes with adopters and detractors. Whatever side you’re on, we genuinely believe that NFTs are an exciting new way of digital ownership, and we should at the very least draw inspiration from it, whether they see mass adoption or not. 


   </div>
  </div>;
};

export default AboutUs;
